<script setup>
const props = defineProps({
    title:       { type: String, default: 'AnimalMatch' },
    subtitle:    { type: String, default: 'Merging Souls with the Spirit of Nature' },
    heroIcon:    { type: String, default: '🐾' },
    currentUser: { type: Object, default: null },
    isGuestUser: { type: Boolean, default: false },
});
</script>

<template>
  <div class="px-8 py-12 bg-lds-bg-card rounded-3xl shadow-lds-lg border-2 border-lds-primary/20 relative overflow-hidden flex flex-col md:flex-row items-center justify-between w-full gap-8">
    <div class="absolute top-0 right-0 p-8 opacity-5 text-9xl pointer-events-none">
        {{ props.heroIcon }}
    </div>
        
    <div class="flex flex-col gap-4 relative z-10 w-full text-center md:text-left">
      <h1 class="text-5xl font-lds-heading font-black text-transparent bg-clip-text bg-gradient-to-r from-lds-primary to-lds-accent">
        {{ props.title }}
      </h1>
      <p class="text-xl text-lds-text-secondary font-medium italic opacity-90 max-w-xl mx-auto md:mx-0">
        {{ props.subtitle }}
      </p>
    </div>
  </div>
</template>
